import { useState } from "react";
import ButtonComponent from "../../../../components/ButtonComponent";
import {
  RedefinirSenhaTokenAcion,
  autenticarUsuario,
} from "../../../../store/actions/usuario";
import { removeDots } from "../../../../helpers/removeDots";
import { Grid } from "@mui/material";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

function CriarNovaSenha({ closeModal, cpf, token }) {
  const [exibirSenha, setExibirSenha] = useState(false);
  const navigate = useNavigate();
  const [dados, setDados] = useState({
    password: "",
    confirmPassword: "",
  });

  const [disabledButton, setDisabledButton] = useState(false);

  const [valido, setValido] = useState({
    tamanho: false,
    letrasMaiusculas: false,
    numeros: false,
  });

  const validarSenha = (valor) => {
    const tamanhoValido = valor?.length >= 8;
    const letrasMaiusculasValidas = (valor.match(/[A-Z]/g) || [])?.length >= 2;
    const numerosValidos = (valor.match(/[0-9]/g) || [])?.length >= 2;

    setValido({
      tamanho: tamanhoValido,
      letrasMaiusculas: letrasMaiusculasValidas,
      numeros: numerosValidos,
    });
  };

  const todosVerdadeiros = Object.values(valido).every(
    (valor) => valor === true
  );

  const comparacaoSenhas = dados.password === dados.confirmPassword;
  const ErrorValidationPass = todosVerdadeiros && comparacaoSenhas;

  const handlePasswordChange = (event) => {
    setDados({ password: event.target.value });
    validarSenha(event.target.value);
  };

  async function RedefinirSenhaToken() {
    setDisabledButton(true);
    try {
      await RedefinirSenhaTokenAcion({
        cpf: removeDots(cpf),
        token: token,
        password: dados.password,
      }).then(async (resp) => {
        await autenticarUsuario(removeDots(cpf), dados.password);
        navigate("/app/assinatura", { replace: true });
        setDisabledButton(false);
      });
    } catch (e) {
      setDisabledButton(false);
    }
  }

  return (
    <div style={{ flexDirection: "column", display: "flex" }}>
      <span style={styles.title}>Recebeu o código?</span>
      <span style={styles.description}>Crie uma nova senha</span>

      <span style={{ ...styles.description, fontSize: 12, marginTop: 30 }}>
        Crie uma nova senha para acessar o app Fynd
      </span>

      <Grid container spacing={2} style={{ marginBottom: 20 }}>
        <Grid item sm={12} xs={12}>
          <input
            style={{ ...styles.inputStyle, width: "100%", fontSize: 14 }}
            value={dados.password}
            onChange={handlePasswordChange}
            placeholder="Senha"
            type={exibirSenha ? "text" : "password"}
          />
        </Grid>
      </Grid>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          style={styles.buttonTertiary}
          onClick={() => setExibirSenha(exibirSenha ? false : true)}
        >
          {exibirSenha ? "Esconder senha" : "Exibir senha"}
        </button>
      </div>
      <div style={{ marginLeft: 15, marginTop: 15 }}>
        <div style={styles.viewValidation}>
          {valido.tamanho ? (
            <CheckBox fontSize="16px" style={{ color: "#91D7A9" }} />
          ) : (
            <CheckBoxOutlineBlank
              fontSize="16px"
              style={{ color: "#191919" }}
            />
          )}
          <span style={styles.textValidation}>Mínimo 8 caracteres</span>
        </div>
        <div style={styles.viewValidation}>
          {valido.letrasMaiusculas ? (
            <CheckBox fontSize="16px" style={{ color: "#91D7A9" }} />
          ) : (
            <CheckBoxOutlineBlank
              fontSize="16px"
              style={{ color: "#191919" }}
            />
          )}
          <span style={styles.textValidation}>
            No mínimo 2 letras maiúsculas
          </span>
        </div>

        <div style={styles.viewValidation}>
          {valido.numeros ? (
            <CheckBox fontSize="16px" style={{ color: "#91D7A9" }} />
          ) : (
            <CheckBoxOutlineBlank
              fontSize="16px"
              style={{ color: "#191919" }}
            />
          )}
          <span style={styles.textValidation}>No mínimo 2 números</span>
        </div>
      </div>

      <div
        style={{
          marginTop: 40,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button style={styles.buttonTertiary} onClick={() => closeModal(false)}>
          Fechar
        </button>

        <ButtonComponent
          disabled={disabledButton}
          onClick={() => RedefinirSenhaToken()}
        >
          Continuar
        </ButtonComponent>
      </div>
    </div>
  );
}

const styles = {
  title: {
    fontSize: 18,
    fontWeight: "600",
  },
  description: {
    fontSize: 14,
  },
  buttonTertiary: {
    border: "none",
    background: "transparent",
    fontWeight: "600",
    textDecorationLine: "underline",
    cursor: "pointer",
    color: "#191919",
  },
  inputStyle: {
    borderRadius: 18,
    padding: 16,
    marginTop: 15,
    border: "1px solid #bcbcbc",
    width: "70%",
    fontSize: 24,
    textAlign: "center",
  },
  textValidation: {
    fontSize: 12,
    paddingLeft: 10,
  },
};

export default CriarNovaSenha;
